import { ActionReducerMapBuilder, PayloadAction } from '@reduxjs/toolkit';
import { getDeposit } from '../ordersThunk';
import { Deposit, OrdersState } from '../types';

export const getDepositReducer = (builder: ActionReducerMapBuilder<OrdersState>) => {
	builder
		.addCase(
			getDeposit.fulfilled,
			(state, action: PayloadAction<Deposit>) => {
        state.orderBookingData.deposit = action.payload;
			},
		)
};